import 'swiper/css';
import 'swiper/css/pagination';
import './styles/SwiperCustomPagination.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { Button } from '../Button';
import config from '../../config';

// Фото сверх лимита (и не первое): блюр + подсказка и кнопки
function LockedPhoto({ photo, index, heightClassName }) {
  const navigate = useNavigate();

  return (
    <div className="relative w-full">
      <img
        src={photo}
        alt={`Фото ${index + 1}`}
        className={`z-[1] w-full ${heightClassName || 'h-[544px]'} object-cover blur-[14px] scale-[1.08] select-none`}
      />

      <div className="absolute inset-0 z-[5]  flex flex-col items-start justify-start gap-[20px] px-6 bg-black/30 pt-[32px]">
        <div className="flex flex-col items-center gap-[10px]">
          <img src="/icons/camera-icon.svg" alt="camera-icon" />
          <p className="font-raleway font-bold text-white text-[20px] text-center">
            Видно столько фото, сколько загружено у вас
          </p>
          <p className="text-white/80 font-semibold text-center">
            Добавьте новые или перейдите на Premium чтобы видеть все сразу
          </p>
        </div>

        <div className="flex flex-col gap-[10px] w-full">
          <Button className="w-full text-[18px] font-medium h-[56px]" onClick={() => navigate(config.ROUTES.PREMIUM)}>
            Смотреть все с Premium
          </Button>
          <button
            type="button"
            onClick={() => navigate(config.ROUTES.PROFILE.PHOTO)}
            className="h-[56px] w-full text-[18px] font-medium rounded-[400px] border border-[#A1F69E] text-[#A1F69E] font-raleway"
          >
            Добавить фото
          </button>
        </div>
      </div>
    </div>
  );
}

// visibleCount — сколько фото доступно к просмотру (по умолчанию без ограничений).
// Первое фото видно всегда, лимит не применяется.
export function ProfilePhotos({ children, photos, heightClassName, visibleCount = Infinity }) {
  return (
    <div className="relative w-full rounded-[16px]">
      <div className="w-full relative">
        <div
          className="custom-pagination"
          style={{
            position: 'absolute',
            top: 0,
            zIndex: 10,
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        ></div>
      </div>
      <div className="relative">
        <Swiper
          modules={[Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          className={`w-full ${heightClassName || 'h-[560px]'} rounded-tl-[16px] rounded-tr-[16px]`}
          pagination={{
            el: '.custom-pagination'
          }}
        >
          {photos && photos.length > 0 ? (
            photos.map((photo, index) => (
              <SwiperSlide key={index}>
                {index === 0 || index < visibleCount ? (
                  <img
                    src={photo}
                    alt={`Фото ${index + 1}`}
                    className={`z-[1] w-full ${heightClassName || 'h-[544px]'} object-cover`}
                  />
                ) : (
                  <LockedPhoto photo={photo} index={index} heightClassName={heightClassName} />
                )}
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide>
              <div
                className={`z-[1] w-full ${heightClassName || 'h-[544px]'} bg-[#FFFFFF1A] flex items-center justify-center text-white`}
              >
                Фото не загружены
              </div>
            </SwiperSlide>
          )}
        </Swiper>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-4 z-10">{children}</div>
        <div
          className="absolute left-0 right-0 bottom-0 w-full h-[150px] z-[5] pointer-events-none"
          style={{
            background: 'linear-gradient(to top, black 30%, transparent 100%)'
          }}
        />
      </div>
    </div>
  );
}

/* watcher-kick */
